import { faClose, faKey, faLock } from "@fortawesome/free-solid-svg-icons"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import { SIZE } from "../../../configuration/Sizes"
import THEME from "../../../configuration/Theme"
import { Employee } from "../../../Objects/Employee/Employee"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { useTranslation } from "react-i18next"
import { useEmployerLogged } from "../../../context/useEmployeeContext"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import InputField from "../../../components/InputField/InputField"
import GetSpace from "../../../utils/space"
import { INPUT_SIZE } from "../../../configuration/InputSize"
import { useCreateChangePassword } from "../../../hooks/ChangePassword/useCreateChangePassword"
import { useSaveChangePassword } from "../../../hooks/ChangePassword/useSaveChangePassword"
import { useMessage } from "../../../context/useMessageContext"

export interface ChangePasswordPopupProbs {
  employee: Employee
  onClonse: () => void
}

export const ChangePasswordPopup: React.FC<ChangePasswordPopupProbs> = ({ employee, onClonse }) => {
  const { t } = useTranslation("employee")

  const { newPassword, currentPassword, handleSubmitForm, handleCurrentPasswordChange, handleNewPasswordChange } =
    useCreateChangePassword()

  const { setMessage } = useMessage()
  const { handleSave } = useSaveChangePassword()

  const { userEmployee } = useEmployerLogged()

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()

    handleSave(handleSubmitForm(userEmployee.isMaster, employee.employeeId), () => {
      onClonse()

      setMessage(t("label_title_change_password"), t("label_description_change_password_success"))
    })
  }

  return (
    <div className={defaultStyle.overlay}>
      <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
        <div className={defaultStyle.alert1}>
          <TitlePageResponsiveIconSmall
            title={t("label_title_change_password")}
            icon={faKey}
            children={
              <ButtonIcon
                sizeNumber={SIZE.buttonCloseIconSize}
                bgColor={THEME.colors.buttonBGCloseColor}
                iconColor={THEME.colors.buttonFGCloseColor}
                icon={faClose}
                onClick={onClonse}
                size="small"
                descriptionKey="interactionDescriptions:pages.myRestaurant.employees.changePasswordPupop.button.onClonse"
              />
            }
          />

          <GetSpace top={5} />

          <form onSubmit={handleSubmit}>
            <>
              <div className="p-1">
                {!userEmployee.isMaster && (
                  <>
                    <InputField
                      maxLength={INPUT_SIZE.EMPLOYEE.mail}
                      type="password"
                      placeholder={t("label_current_password_place_holder")}
                      onInvalidMessage={t("label_current_password_onInvalidMessage")}
                      icon={faKey}
                      value={currentPassword}
                      onChange={handleCurrentPasswordChange}
                      required
                      descriptionKey="interactionDescriptions:pages.myRestaurant.employees.changePasswordPupop.input.currentPasswordPlaceHolder"
                    />

                    <GetSpace top={10} />
                  </>
                )}

                <InputField
                  maxLength={INPUT_SIZE.EMPLOYEE.password}
                  type="password"
                  placeholder={t("label_new_password_place_holder")}
                  onInvalidMessage={t("label_new_password_onInvalidMessage")}
                  icon={faLock}
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  required
                  descriptionKey="interactionDescriptions:pages.myRestaurant.employees.changePasswordPupop.input.newPasswordPlaceHolder"
                />
              </div>

              <div className={defaultStyle.divisionBar}></div>

              <div className="flex justify-end items-center w-full gap-2">
                <Button
                  label={t("buttons:button_save")}
                  typeButton="submit"
                  type="primary"
                  size="medium"
                  bgColor={THEME.colors.buttonBGSaveColor}
                  descriptionKey="interactionDescriptions:pages.myRestaurant.employees.changePasswordPupop.button.save"
                />
              </div>
            </>
          </form>
        </div>
      </Animate>
    </div>
  )
}
